import jwt_decode from 'jwt-decode';

import { injectScriptTag } from './utils';

import { SOCIAL_EXTERNAL_IDENTITY_PROVIDER_GOOGLE } from './constants';

export const injectOneTap = ({
    id = 'google-id-auth-one-tap',
    src = 'https://accounts.google.com/gsi/client',
    asyncStrategy = 'async',
    clientId,
    onVerified,
    onReturn,
    onTriggered,
    onNoDisplayed,
    onBlocked,
    dispatch,
}) => {
    injectScriptTag({
        doc: document,
        id,
        src,
        asyncStrategy,

        onLoad: () => {
            googleInitOneTap({
                clientId,
                onVerified,
                onReturn,
                onTriggered,
                onNoDisplayed,
                onBlocked,
                dispatch,
            });
        },
    });
};
const googleInitOneTap = ({
    clientId,
    onVerified,
    onReturn,
    onTriggered,
    onNoDisplayed,
    onBlocked,
    dispatch,
}) => {
    /*eslint-disable no-undef*/
    google.accounts.id.initialize({
        client_id: clientId,
        callback: (response) => {
            handleCredentialResponse({
                response,
                onReturn,
                onVerified,
                dispatch,
            });
        },
    });

    google.accounts.id.prompt((notification) => {
        if (notification.isDisplayed() && onTriggered) {
            dispatch(onTriggered(SOCIAL_EXTERNAL_IDENTITY_PROVIDER_GOOGLE));
        } else if (notification.isNotDisplayed() && onNoDisplayed) {
            dispatch(onNoDisplayed(notification.getNotDisplayedReason()));
        } else if (notification.isSkippedMoment() && onBlocked) {
            dispatch(onBlocked(notification.getSkippedReason()));
        }
    });
};
const handleCredentialResponse = ({
    response,
    onReturn,
    onVerified,
    dispatch,
}) => {
    const auth = jwt_decode(response.credential);
    if (onReturn) {
        dispatch(onReturn(SOCIAL_EXTERNAL_IDENTITY_PROVIDER_GOOGLE, '', true));
    }
    dispatch(
        onVerified(SOCIAL_EXTERNAL_IDENTITY_PROVIDER_GOOGLE, {
            accessToken: response.credential,
            email: auth.email,
            firstName: auth.given_name,
            lastName: auth.family_name,
            picture: auth.picture,
            userID: auth.sub,
            sourceProvider: SOCIAL_EXTERNAL_IDENTITY_PROVIDER_GOOGLE,
        }),
    );
};
